// Libraries
var React = require("react");

// Components
var EndeavorVideoEmbedStream = require("./EndeavorVideoEmbedStream");
var VideoEmbedStream = require("./VideoEmbedStream");

class VideoEmbed extends React.Component {
  render() {
    if (this.props.type !== "STREAM") {
      return null;
    }
    
    if(this.props.data.playerId === "endeavor") {
      return (
        <EndeavorVideoEmbedStream
          entryId={this.props.data.entryId}
          publishedDate={this.props.publishedDate}
          autoplay={this.props.autoplay}
          exampleResponse={this.props.exampleResponse}
          contentTags={this.props.data.contentTagsString}
          videoPublicUrl={this.props.data.videoPublicUrl}
        />
      );
    } else {
      return (
        <VideoEmbedStream
          entryId={this.props.data.entryId}
          playerId={this.props.data.playerId}
          partnerId={this.props.data.partnerId} 
          autoplay={this.props.autoplay}
          contentTags={this.props.data.contentTagsString}
          videoPublicUrl={this.props.data.videoPublicUrl}
        />
      );
    } 
  }
}

module.exports = VideoEmbed;



// WEBPACK FOOTER //
// ./src/components/Video/VideoEmbed.js